// extracted by mini-css-extract-plugin
export default {"home":"home_home__UuC0M","home-content":"home_home-content__Fqdud"};